import axios from 'axios';
import _find from 'lodash/find';
import { getElmoExperiments } from './action-app';
import * as types from '../constants/ActionTypes';
import { parseAutoComplete } from '../../../../lib/dataParse';

const BNA_CHANNEL = 'BNA';
const PPC_DEFAULT_SEARCH = 'GOPS_smarthelp_pcc_default_search';
const RELATED_ARTICLE_URL = '/smarthelp/related-article';

const requestDefaultSuggestion = () => ({ type: types.REQUEST_DEFAULT_PCC_ARTICLES });

const receivedDefaultSuggestionError = () => ({ type: types.RECEIVED_DEFAULT_PCC_ARTICLES_ERROR });

const receivedDefaultSuggestion = payload => ({ type: types.RECEIVED_DEFAULT_PCC_ARTICLES, payload });

const getSanitizedValue = (value) => {
  const returnValue = value ? value.trim() : '';
  try {
    return encodeURIComponent(returnValue);
  } catch (error) {
    return returnValue;
  }
};

// Base on the first BNA article to fetch PCC auto-complete suggestions
const fetchDefaultSuggestion = articleTitle => (dispatch) => {
  dispatch(requestDefaultSuggestion());
  return axios.get(`${RELATED_ARTICLE_URL}?q=${getSanitizedValue(articleTitle)}`)
    .then((response) => {
      const suggestionArticles = parseAutoComplete(response.data);
      dispatch(receivedDefaultSuggestion(suggestionArticles));
    })
    .catch(() => {
      dispatch(receivedDefaultSuggestionError());
    });
};

// Get default search articles base on the first BNA article in the popular articles
const fetchDefaultPCCArticles = (dispatch, popularResponse) => {
  if (!popularResponse || !Array.isArray(popularResponse.recommendedSolutions)) {
    return null;
  }

  // get the first BNA article; return null if there is no BNA article in the recommended articles
  const BNAArticle = _find(popularResponse.recommendedSolutions, recommend => recommend.channel === BNA_CHANNEL);
  if (!BNAArticle) {
    return null;
  }

  dispatch(getElmoExperiments(PPC_DEFAULT_SEARCH));
  return dispatch(fetchDefaultSuggestion(BNAArticle.articleTitle));
};


module.exports = {
  fetchDefaultPCCArticles,
  PPC_DEFAULT_SEARCH,
};
